/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import {
  ApolloClient,
  ApolloProvider,
  HttpLink,
  InMemoryCache
} from '@apollo/client';
import { useSelector } from 'react-redux';
import ConditionalWrapper from '@justpark/ui/src/components/ConditionalWrapper';
import cacheConfig from '../apollo/cacheConfig';
import { selectLanguage } from '../stores/partner';

const getApolloClient = (() => {
  let client;
  return (locale) => {
    // eslint-disable-next-line no-underscore-dangle
    const apolloState = window.__APOLLO_STATE__;

    if (!client) {
      client = new ApolloClient({
        link: new HttpLink({
          uri: '/graphql',
          headers: {
            'Accept-Language': locale
          }
        }),
        cache: new InMemoryCache(cacheConfig).restore(apolloState)
      });
    }

    return client;
  };
})();

/**
 * Hoc to wrap a compoent in the ApolloProvider
 * Usually Provider would just wrap the entire application, however we don't need Apollo on every page
 * Once GraphQL is more widley adopted and this HoC can be removed and moved inside src/client.js
 *
 * Note: This uses ConditionalWrapper, during a SSR the apollo client if provided by the server
 */
const withApollo = () => (BaseComponent) => (props) => {
  const locale = useSelector(selectLanguage);
  return (
    <ConditionalWrapper
      condition={__CLIENT__}
      wrapper={(children) => (
        <ApolloProvider client={getApolloClient(locale)}>
          {children}
        </ApolloProvider>
      )}
    >
      <BaseComponent {...props} />
    </ConditionalWrapper>
  );
};

export default withApollo;
